import { render, staticRenderFns } from "./NamespaceList.vue?vue&type=template&id=d7adbace&"
import script from "./NamespaceList.vue?vue&type=script&lang=js&"
export * from "./NamespaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports